import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getOrders (page, pageSize,
      customerUid, resellerUid,
      dates,
      minAmount, maxAmount) {
    var getOrdersUrl = '/v1/admin/orders/allOrders'
    var querystringParams = []
    if (Number.isInteger(page) && page >= 0) {
      querystringParams.push(`page=${page}`)
      if (pageSize) {
        querystringParams.push(`pageSize=${pageSize}`)
      }
    }
    if (customerUid) {
      querystringParams.push(`customerUid=${customerUid}`)
    }
    if (resellerUid) {
      querystringParams.push(`resellerUid=${resellerUid}`)
    }
    if (dates && dates.length > 0) {
      querystringParams.push(`startDateTime=${dates[0]}`)
      if (dates.length === 2) {
        querystringParams.push(`endDateTime=${dates[1]}`)
      }
    }
    if (minAmount) {
      querystringParams.push(`minAmount=${minAmount}`)
    }
    if (maxAmount) {
      querystringParams.push(`maxAmount=${maxAmount}`)
    }

    if (querystringParams.length > 0) {
      getOrdersUrl += '?' + querystringParams.join('&')
    }
    return Api()
      .get(getOrdersUrl)
      .then(async function (response) {
        return { success: true, value: response }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Order.Messages.GetOrdersErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getManualOrderLines () {
    return Api()
      .get('/v1/admin/orders/orderLinesForManualProcessing')
      .then(async function (response) {
        return { success: true, value: response }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Order.Messages.GetOrdersErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async updateOrderLine (orderLineDetails) {
    return Api()
      .post('/v1/admin/orders/' + orderLineDetails.orderLineId + '/licensing', {
        vendorReferenceIdentifier: orderLineDetails.vendorReferenceIdentifier,
        serialNumber: orderLineDetails.serialNumber,
        completed: !!orderLineDetails.completed,
      })
      .then(async function (response) {
        return { success: true, value: response }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Order.Messages.UpdateOrderLineErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
}
